<nav style="background-color: rgb(47, 153, 142);">
  <div style="text-align: right;"><button class="btn-danger" (click)="logout()" >Cerrar sesión</button></div>
  <!-- <div style="text-align: right;"><button class="btn-danger" (click)="customScript()" >CustomScript</button></div> -->
</nav>

<div style="background-color: lightgray; margin: 7px;">
  

      <ul ngbNav #nav="ngbNav" [(activeId)]="active" class="nav-tabs">
        
        <li [ngbNavItem]="1">
          <a ngbNavLink>Crear autoridades</a>
          <ng-template ngbNavContent>
            <app-componente-data3></app-componente-data3>
          </ng-template>
        </li>

        <li [ngbNavItem]="2">
          <a ngbNavLink>Gestionar empresas</a>
          <ng-template ngbNavContent>
            <app-componente-data2></app-componente-data2>
          </ng-template>
        </li>

        <li [ngbNavItem]="3">
          <a ngbNavLink>Crear usuarios sin email corporativo</a>
          <ng-template ngbNavContent>
            <app-componente-data4></app-componente-data4>
          </ng-template>
        </li>

        <li [ngbNavItem]="4">
          <a ngbNavLink>Gestionar usuarios</a>
          <ng-template ngbNavContent>
            <app-componente-data5></app-componente-data5>
          </ng-template>
        </li>

        <li [ngbNavItem]="5">
          <a ngbNavLink>Gestionar locaciones</a>
          <ng-template ngbNavContent>
            <app-componente-data6></app-componente-data6>
          </ng-template>
        </li>

        <li [ngbNavItem]="6">
          <a ngbNavLink>Reporte por empresa</a>
          <ng-template ngbNavContent>
            <app-componente-data7></app-componente-data7>
          </ng-template>
        </li>

        <li [ngbNavItem]="7">
          <a ngbNavLink>CustomScript</a>
          <ng-template ngbNavContent>
            <app-componente-customscript></app-componente-customscript>
          </ng-template>
        </li>
        
      </ul>
      
      <div [ngbNavOutlet]="nav" class="mt-2"></div>
</div>


